export const GET_USER_DATA = '@user/getData';